import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
`;

const ErrorContainer = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 2px solid ${props => props.theme.errorBorder};
  background-color: ${props => props.theme.errorBg};
  animation: ${props => props.shake ? shake : 'none'} 0.4s ease-in-out;
`;

const ErrorText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.errorText};
  
  & + & {
    margin-top: 0.5rem;
  }
`;

const ErrorDisplay = ({ errors, questionCode }) => {
  const [shake, setShake] = useState(false);
  
  // Filter errors for this specific question
  const questionErrors = errors?.filter(err => {
    // Handle both string errors and object errors
    if (typeof err === 'string') {
      return err === questionCode;
    }
    return err.QuestionCode === questionCode;
  }) || [];

  // Trigger shake animation when errors appear
  useEffect(() => {
    if (questionErrors.length > 0) {
      setShake(true);
      const timer = setTimeout(() => setShake(false), 400);
      return () => clearTimeout(timer);
    }
  }, [questionErrors.length]);

  // Don't render anything if there are no errors
  if (questionErrors.length === 0) {
    return null;
  }

  return (
    <ErrorContainer shake={shake}>
      {questionErrors.map((err, index) => (
        <ErrorText key={index}>
          {typeof err === 'string' ? 'Please provide an answer to continue.' : err.error || 'Please provide an answer to continue.'}
        </ErrorText>
      ))}
    </ErrorContainer>
  );
};

export default ErrorDisplay;
